import React from 'react';

const SearchSemanticPanel = ({
  showSemanticSearch, setShowSemanticSearch,
  esQuery, setEsQuery,
  esResults, esLoading, esTotal,
  esSyncing,
  onSearch, onSync
}) => {
  return (
    <div className="card" style={{ marginBottom: 20, background: 'linear-gradient(135deg, rgba(6, 182, 212, 0.08), rgba(252, 211, 77, 0.08))', border: '1px solid rgba(6, 182, 212, 0.25)' }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: showSemanticSearch ? 12 : 0 }}>
        <button
          onClick={() => setShowSemanticSearch(v => !v)}
          data-testid="toggle-semantic-search"
          style={{ background: 'none', border: 'none', color: '#22d3ee', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: 8, fontSize: '0.95rem', fontWeight: 600, padding: 0 }}
        >
          <i className="fas fa-brain" /> Semantic Search (Elasticsearch)
          <i className={`fas fa-chevron-${showSemanticSearch ? 'up' : 'down'}`} style={{ fontSize: '0.7rem' }} />
        </button>
        {showSemanticSearch && (
          <button onClick={onSync} disabled={esSyncing} data-testid="es-sync-btn"
            style={{ background: 'rgba(16,185,129,0.15)', border: '1px solid rgba(16,185,129,0.3)', color: '#10b981', padding: '5px 12px', borderRadius: 8, cursor: 'pointer', fontSize: '0.75rem' }}>
            {esSyncing ? 'Syncing...' : 'Sync to ES'}
          </button>
        )}
      </div>
      {showSemanticSearch && (
        <div>
          <div style={{ display: 'flex', gap: 8, marginBottom: 12 }}>
            <input
              value={esQuery}
              onChange={e => setEsQuery(e.target.value)}
              onKeyDown={e => e.key === 'Enter' && onSearch()}
              placeholder="Search your indexed data semantically..."
              data-testid="semantic-search-input"
              style={{ flex: 1, background: 'rgba(253, 251, 247,0.6)', border: '1px solid rgba(6,182,212,0.3)', borderRadius: 8, padding: '8px 14px', color: '#e4e4e7', fontSize: '0.85rem' }}
            />
            <button onClick={onSearch} disabled={esLoading} data-testid="semantic-search-btn"
              style={{ background: 'linear-gradient(135deg, #0891b2, #FCD34D)', border: 'none', color: '#0F172A', padding: '8px 18px', borderRadius: 8, cursor: 'pointer', fontWeight: 600, fontSize: '0.85rem' }}>
              {esLoading ? 'Searching...' : 'Search'}
            </button>
          </div>
          {esResults.length > 0 && (
            <div>
              <div style={{ color: '#a1a1aa', fontSize: '0.75rem', marginBottom: 8 }}>{esTotal} results found</div>
              <div style={{ display: 'flex', flexDirection: 'column', gap: 6, maxHeight: 350, overflowY: 'auto' }}>
                {esResults.map((r, i) => (
                  <div key={r.id || i} data-testid={`es-result-${i}`} style={{
                    background: 'rgba(253, 251, 247,0.5)', border: '1px solid rgba(6,182,212,0.15)', borderRadius: 8, padding: '10px 14px'
                  }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', gap: 8 }}>
                      <a href={r.url} target="_blank" rel="noopener noreferrer"
                        style={{ color: '#22d3ee', fontWeight: 600, fontSize: '0.85rem', textDecoration: 'none', flex: 1 }}
                        dangerouslySetInnerHTML={{ __html: r.highlight_title || r.title || 'Untitled' }}
                      />
                      <span style={{ color: '#f59e0b', fontSize: '0.65rem', flexShrink: 0, background: 'rgba(245,158,11,0.12)', padding: '2px 6px', borderRadius: 4 }}>
                        {r.score?.toFixed(1)}
                      </span>
                    </div>
                    <div style={{ color: '#a1a1aa', fontSize: '0.75rem', marginTop: 4 }}
                      dangerouslySetInnerHTML={{ __html: r.highlight_snippet || r.snippet || r.content_preview || '' }}
                    />
                    <div style={{ display: 'flex', gap: 6, marginTop: 6, flexWrap: 'wrap' }}>
                      <span style={{ fontSize: '0.65rem', color: '#71717a', background: 'rgba(255, 255, 255, 0.85)', padding: '1px 6px', borderRadius: 4 }}>{r.root_domain}</span>
                      <span style={{ fontSize: '0.65rem', color: '#047857', background: 'rgba(253, 224, 71,0.1)', padding: '1px 6px', borderRadius: 4 }}>{r.article_type}</span>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}
          {esResults.length === 0 && !esLoading && esQuery && (
            <p style={{ color: '#71717a', fontSize: '0.8rem', textAlign: 'center', padding: 20 }}>
              No results found. Try syncing your data first with the "Sync to ES" button.
            </p>
          )}
        </div>
      )}
    </div>
  );
};

export default SearchSemanticPanel;
